import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { logOut } from '../../FirebaseAuth';

const DashboardLayout = ({ user, onLogout }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const isSuperAdmin = user.role === 'SuperAdmin';

    return (
        <div className="relative min-h-screen md:flex">
            {/* Pass the onLogout function to the sidebar */}
            <Sidebar user={user} isOpen={sidebarOpen} setIsOpen={setSidebarOpen} onLogout={onLogout} />
            
            <div className="flex-1 flex flex-col">
                {/* --- Mobile Header --- */}
                <div className="md:hidden flex items-center justify-between bg-white shadow-sm p-4">
                    <button onClick={() => setSidebarOpen(prev => !prev)} className="text-gray-500 focus:outline-none">
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 12h16" />
                        </svg>
                    </button>
                    <div className="text-xl font-bold">
                        {isSuperAdmin ? 
                            <><span className="text-red-500">Super</span><span>Admin</span></> : 
                            <><span className="text-primary">School</span><span>Admin</span></>
                        }
                    </div>
                    {/* A spacer to push the title to the center if needed */}
                    <div className="w-6"></div>
                </div>
                
                {/* --- Desktop Header --- */}
                <header className="hidden md:flex justify-end items-center bg-white shadow-sm p-4">
                    <div className="flex items-center">
                        <span className="text-gray-600 mr-4">Welcome, {user.email} ({user.role})</span>
                        {/* Logout button has been moved to the sidebar */}
                    </div>
                </header>
                
                <main className="flex-1 overflow-y-auto p-6 bg-gray-200">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
